import React, { lazy } from 'react';
import { featureFlags } from '@config/featureFlags';
import type { QuestionRouteProps } from './QuestionRouteGate';

// Lazy: the gate draws the Post sheet (vaul), which nothing needs while the flag is off, so the
// entry chunk router.tsx sits in stays as it was before the sheet existed (TECH-197 FE-4).
const QuestionRouteGate = lazy(() =>
  import('./QuestionRouteGate').then(m => ({ default: m.QuestionRouteGate })),
);

/**
 * `/questions/:slugOrId` as the route table draws it: a URL with no sheet behind it (a link, a
 * refresh, a push tap, or a post the sheet does not open). An in-app tap on a poll never reaches
 * here; it carries a background and PostSheetOutlet draws the sheet over it.
 *
 * Flag off: the post page, exactly as before. Flag on: one route for posts and polls that learns
 * the kind only after the read, so until then it shows a neutral state (the sheet's skeleton over
 * a blank ground) and never the post page, which a poll must not flash. Then a post gets the post
 * page, and a poll gets the sheet over its computed background (TECH-197 1b / 1d).
 */
export const QuestionRoute: React.FC<QuestionRouteProps> = ({ postPage }) =>
  featureFlags.postSheet ? <QuestionRouteGate postPage={postPage} /> : postPage;
